import React, { useState, useEffect } from "react";
import { Space, Button, Radio, Form, Input, Select, Divider, Col } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";
import { get } from "lodash";
import getFormItemRules from "../shared/form-helper";
import AddUser from "./adduser";

const { Option } = Select;

const TargetUsers = (properties) => {
  const {
    form,
    customValidate,
    validateMessage,
    setValidateMessage,
    setCustomValidate,
    users,
    fetchUser,
    broadCast,
  } = properties;
  const [uploadVisible, setUploadVisible] = useState(false);
  const [filterByUser, setFilterByUser] = useState("");
  const [selectedUser, setSelectedUser] = useState([]);
  const filterUserBy = form.getFieldValue("filterUserBy");
  const [openUserModal, setUserModal] = useState(false);
  const [selectedBroadCastUser, setSelectedBroadCastUser] = useState([]);

  useEffect(() => {
    const campaignTags = form.getFieldValue("campaign_tags");
    if (campaignTags === "all_users") {
      setFilterByUser("all_users");
    }
    if (campaignTags === "filter_users_by") {
      setFilterByUser("filter_users_by");
      form.setFieldsValue({
        filterByUser: selectedUser,
        campaign_type: "Whatsapp",
      });
    }
    if (campaignTags === "board_cast") {
      const selectedBroadCast = form.getFieldValue("boardCast");
      setFilterByUser("board_cast");
      setSelectedBroadCastUser(selectedBroadCast);
      form.setFieldsValue({
        boardCast: selectedBroadCast,
      });
    }
    form.setFieldsValue({
      campaign_type: "Whatsapp",
    });
  }, []);

  const onSelectCampaign = (e) => {
    const type = get(e, "target.value", "");
    if (type === "SMS" || type === "Email" || type === "Whatsapp") {
      setUploadVisible(true);
    } else {
      setUploadVisible(false);
    }
  };

  const onSelectUser = (value) => {
    form.setFieldsValue({
      filterUserBy: value,
    });
    setSelectedUser(value);
    setValidateMessage("");
    setCustomValidate("success");
  };
  const onChangeBroadCast = (value) => {
    form.setFieldsValue({
      boardCast: value,
    });
    setSelectedBroadCastUser(value);
    setValidateMessage("");
    setCustomValidate("success");
  };

  const selectAudienceChange = (e) => {
    if (e.target.value === "all_users") {
      form.setFieldsValue({
        selected_customers: "all_users",
        campaign_tags: "all_users",
      });
      setFilterByUser(e.target.value);
    } else if (e.target.value === "board_cast") {
      form.setFieldsValue({
        selected_customers: "board_cast",
        campaign_tags: "board_cast",
      });
      setFilterByUser(e.target.value);
    } else {
      form.setFieldsValue({
        selected_customers: "filter_users_by",
        campaign_tags: "filter_users_by",
      });
      setFilterByUser(e.target.value);
    }
    setValidateMessage("");
    setCustomValidate("success");
  };

  const handleAddUser = () => {
    setUserModal(true);
  };
  const handleClose = () => {
    setUserModal(false);
    fetchUser();
  };
  return (
    <>
      <Divider />
      <div>
        <Col span={8}>
          <Form.Item
            name="campaign_name"
            label="Campaign Name"
            rules={[
              ...getFormItemRules({
                required: true,
              }),
            ]}
          >
            <Input size="large" />
          </Form.Item>
        </Col>
      </div>
      <Divider />
      <div>
        <h3>Select campaign</h3>
        <Form.Item
          name="campaign_type"
          rules={[
            ...getFormItemRules({
              required: true,
            }),
          ]}
        >
          <Radio.Group
            style={{ marginRight: "10px" }}
            onChange={onSelectCampaign}
          >
            {/* <Radio value="Push">
              <Space>
                <MobileOutlined />
                Push
              </Space>
            </Radio>
            <Radio value="Email">
              <Space>
                <MailOutlined />
                Email
              </Space>
            </Radio>
            <Radio value="SMS" disabled>
              <Space>
                <MessageOutlined />
                SMS
              </Space>
            </Radio> */}
            <Radio value="Whatsapp">
              <Space>
                <WhatsAppOutlined />
                Whatsapp
              </Space>
            </Radio>
          </Radio.Group>
        </Form.Item>
      </div>
      <Divider />
      <div>
        <h3>Select audience</h3>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={handleAddUser} type="primary">
            Add New User
          </Button>
        </div>

        <Form.Item
          name="selected_audience"
          rules={[
            ...getFormItemRules({
              required: true,
              message: `Audience is required`,
            }),
          ]}
        >
          <Radio.Group
            onChange={(e) => selectAudienceChange(e)}
            name="user_filter"
          >
            <Radio value="all_users">All users</Radio>
            <Radio value="filter_users_by">Filter users by</Radio>
            <Radio value="board_cast">BroadCast</Radio>
          </Radio.Group>
        </Form.Item>
        {filterByUser === "filter_users_by" && (
          <Form.Item validateStatus={customValidate} help={validateMessage}>
            <Col span={8}>
              <Select
                onChange={onSelectUser}
                mode="multiple"
                name="filterUserBy"
                size="large"
                value={filterUserBy}
                placeholder="Select customers"
                className="filter-user"
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .includes(input.toLowerCase()) === true
                }
              >
                {users &&
                  users.map((item) => (
                    <Option key={item?.phone_number} value={item?.phone_number}>
                      {item?.user_name}
                    </Option>
                  ))}
              </Select>
            </Col>
          </Form.Item>
        )}
        {filterByUser === "board_cast" && (
          <Form.Item validateStatus={customValidate} help={validateMessage}>
            <Col span={8}>
              <Select
                onChange={onChangeBroadCast}
                mode="multiple"
                name="boardCast"
                size="large"
                value={selectedBroadCastUser}
                placeholder="Select BroadCast"
                className="filter-user"
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .includes(input.toLowerCase()) === true
                }
              >
                {broadCast &&
                  broadCast.map((item) => (
                    <Option
                      key={item?.board_cast_uid}
                      value={item?.board_cast_uid}
                    >
                      {item?.name}
                    </Option>
                  ))}
              </Select>
            </Col>
          </Form.Item>
        )}
      </div>
      {openUserModal && (
        <AddUser openUserModal={openUserModal} handleClose={handleClose} />
      )}
      <Divider />
    </>
  );
};

export default TargetUsers;
